import React from 'react';
import { withFormik } from 'formik';
import FormControl from 'components/Core/FormControl';
import * as Yup from 'yup';
import Button from 'components/Core/Button';
import TextField from 'components/Core/TextField';
import LoginOptions from 'components/Page/Toolbox/LoginOptions';
import SeparatorLineText from 'components/SeparatorLineText';
import HyperLink from 'components/Core/HyperLink';
import { SignupContainer } from './styles';

const Signup1 = ({ onFinish, socialAuth, openLoginModal, ...otherProps }) => {
  const { values, handleChange, handleBlur, handleSubmit, errors, isValid } = otherProps;

  return (
    <SignupContainer>
      <h4>Welcome to the Toolbox</h4>
      <div>
        <FormControl fullWidth>
          <TextField
            id="email"
            type="text"
            formValid={{ email: errors.email ? -1 : 0 }}
            formErrors={errors}
            values={values}
            placeholderText="Work Email"
            onChange={handleChange}
            onBlur={handleBlur}
            showOnlyFormError
          />
        </FormControl>
        <FormControl fullWidth>
          <Button
            type="secondary"
            width="100%"
            shadow={false}
            button
            disabled={!isValid}
            onClick={handleSubmit}
          >
            Continue
          </Button>
        </FormControl>
      </div>
      <SeparatorLineText text="or with existing account" />
      <LoginOptions onClick={socialAuth} />
      <h6>
        Already a member? <HyperLink onClick={openLoginModal}>Sign in</HyperLink>
      </h6>
    </SignupContainer>
  );
};

const vSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').required('Email is required'),
});

export default withFormik({
  validationSchema: vSchema,
  mapPropsToValues: ({ data }) => data,
  handleSubmit: (values, { props, setErrors }) => {
    props.onFinish(values.email);
  },
})(Signup1);
